// `delay` (ms, default 400) added for mahya's footer "go top" button, which waits 100ms.
// A non-number (e.g. a click event when used as `onClick={scroll_up}`) falls back to 400.
export const scroll_up = (delay = 400) => {
    setTimeout(() => {
        if (typeof document !== "undefined") {
            const element = document.getElementById("top-of-page");
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, Number.isFinite(delay) ? delay : 400);

};

// Scroll the window itself to the top, at once. From chawk-bazar/ciseco GoUp + Pagination and jument Goup,
// which scroll the window (not #top-of-page). `smooth: false` jumps; reduced-motion users get a jump by default.
export const scroll_window_top = ({ smooth = true, respect_reduced_motion = true } = {}) => {
    if (typeof window === "undefined") return;
    const reduced = respect_reduced_motion && typeof window.matchMedia === "function"
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: smooth && !reduced ? "smooth" : "auto" });
};
